<template>
  <div class="characteristic-teach">
    <div class="characteristic-teach-top">
        <div class="title">特色教研</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="characteristic-teach-number">
      <div class="number-item">
        <div class="name">活动数</div>
        <div class="number">354</div>
      </div>
      <div class="number-item">
        <div class="name">资源数</div>
        <div class="number">892</div>
      </div>
      <div class="number-item">
        <div class="name">研讨数</div>
        <div class="number">789</div>
      </div>
      <div class="number-item">
        <div class="name">心得数</div>
        <div class="number">450</div>
      </div>
    </div>
    <div class="characteristic-teach-echars">
        <div id="characteristicEchartsId" style="width: 100%;height: 100%"></div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  name: '',
  data() {
    return {

    }
  },
  methods: {
    initEcharts(){
        let chartDom = document.getElementById('characteristicEchartsId');
        let myChart = echarts.init(chartDom);
        let option;

        option = {
            tooltip: {
                trigger: "axis",
                formatter: function (params) {
                    // var relVal =params[0].name +
                    //     "</br>" +
                    //     "参与人数" +
                    //     params[0].value;
                    var relVal = `<span style="color:#FFFFFF">${params[0].name}</span></br><span style="color:#6EA0D3">参与人数：${params[0].value}</span>`
                    return relVal;
                },
            },
            grid: {
                left: "0px",
                right: "40px",
                bottom: "20px",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                name:"学校",
                data: ["新华小学","高新智慧学校","实验第二中学","高新区实验中学","第七中学"],
                axisLabel: {
                    interval: 0,
                    textStyle: {
                        color: "#6EA0D3",
                        fontSize: "16px",
                    },
                    formatter: function (value) {
                        if(value.length > 4){
                            let name = ""
                            let length = Math.round(value.length / 4);
                            for(let i =0;i<length;i++){
                                let j = i+1<=length ? i+1 : length - 1;
                                name = name ? name + "\n" + value.slice(i*4,j*4) : value.slice(i*4,j*4)
                            }
                            return name
                        }else{
                            return value;
                        }
                    },
                },
                axisTick: {
                    alignWithLabel: true,
                    show:false,
                },
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: "#D6D6D6",
                    },
                },
            },
            yAxis: {
                type: "value",
                name:"参与学校TOP5/人次",
                left: 10,
                axisLine: {
                    show: false,
                    lineStyle: {
                      color: "#D6D6D6",
                    },
                },
                axisLabel: {
                    show: true,
                    verticalAlign: "middle",
                    textStyle: {
                        color: "#6EA0D3",
                    },
                },
                axisTick:{
                    show:false,
                },
                splitLine: {
                    show: false,
                },
                nameTextStyle: {
                    padding: [4, 4, 4, 20],
                }
            },
            series: [
                {
                    data: [20,18,16,14,12],
                    type: "bar",
                    name: "建设",
                    color: "#2B7FFF",
                    barMaxWidth: 16,
                    // label: {
                    //     normal: {
                    //         show: true,
                    //         position: "top",
                    //         color: "#000000",
                    //     },
                    // },
                    itemStyle: {
                        borderRadius: [3, 3, 0, 0],
                    },
                },
            ],
        };

        option && myChart.setOption(option);
    }
  },
  mounted(){
    this.initEcharts();
  }
}
</script>
<style lang='scss' scoped>
.characteristic-teach{
    width: 100%;
    height: 330px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;
    // background: rgba(6,17,52,0.8);
    .characteristic-teach-top{
        position: relative;
        text-align: center;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .characteristic-teach-number{
    display: flex;
    align-items: center;
    justify-content: space-around;
      margin-top: 15px;
    .number-item{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .name{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #7ABFDB;
        margin-right: 5px;
      }
      .number{
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
      }
    }
  }
    .characteristic-teach-echars{
        height: calc(100% - 70px);
        width: 100%;
    }
    .top-left{
          position: absolute;
          top: 0;
          left: 0;
          width: 14px;
          height: 14px;
      }
      .top-right{
          position: absolute;
          top: 0;
          right: 0;
          width: 14px;
          height: 14px;
      }
      .left-bottom{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 14px;
          height: 14px;
      }
      .right-bottom{
          position: absolute;
          bottom: 0;
          right: 0;
          width: 14px;
          height: 14px;
      }
}
</style>